module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"orders":"我的成交","logout":"登出","logoutHint":"确定要退出登录?"},"zh_hk":{"orders":"我的成交","logout":"登出","logoutHint":"確定要退出登錄？"},"en":{"orders":"My Transaction","logout":"Logout","logoutHint":"Confirm log out?"},"ja":{"orders":"取引中","logout":"ログアウト","logoutHint":"ログアウトしてもよろしいですか?"}}')
  delete Component.options._Ctor
}
